// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datagrid-container {
  position: relative;
}
.datagrid-container .datagrid-headers-scroll-patch {
  width: 20px;
  height: 50px;
  position: absolute;
  right: 0;
}
.datagrid-container .datagrid-headers-container {
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #D3E1ED;
}
.datagrid-container .datagrid-headers-container .datagrid-headers {
  display: grid;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F5F9FF;
  border-bottom: 1px solid #E0E6EB;
  height: 37px;
  box-sizing: border-box;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.datagrid-container .datagrid-headers-container .datagrid-headers .datagrid-header {
  min-width: 50px;
  margin: 2px 2px 2px 2px;
  color: #6A8991;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.datagrid-container .datagrid-body {
  overflow-y: scroll;
  max-height: calc(-300px + 100dvh);
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.datagrid-container .datagrid-body .datagrid-row {
  display: grid;
  height: 45px;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  background-color: white;
  border-bottom: 1px solid #DBE7F1;
  color: #000;
  cursor: pointer;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.datagrid-container .datagrid-body .datagrid-row:hover {
  background-color: #c6d9ff;
}
.datagrid-container .datagrid-body .datagrid-row .datagrid-cell {
  min-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  margin: 2px 2px 2px 2px;
}
.datagrid-container .datagrid-body .no-highlight {
  cursor: default;
}
.datagrid-container .datagrid-body .no-highlight:hover {
  background-color: #fff; /* or any other desired background color */
}

.dbsnapshots-grid {
  position: relative;
}
.dbsnapshots-grid .datagrid-headers-scroll-patch {
  width: 20px;
  height: 50px;
  position: absolute;
  right: 0;
}
.dbsnapshots-grid .datagrid-headers-container {
  overflow-y: scroll;
  overflow-x: hidden;
  border-top: 1px solid #D3E1ED;
}
.dbsnapshots-grid .datagrid-headers-container .datagrid-headers {
  display: grid;
  align-items: center;
  column-gap: 2px;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F5F9FF;
  border-bottom: 1px solid #E7E7E6;
  min-width: -moz-fit-content;
  min-width: fit-content;
  height: 30px;
  /* vertical separators between header columns */
}
.dbsnapshots-grid .datagrid-headers-container .datagrid-headers .datagrid-header {
  min-width: 50px;
  margin: 0;
  color: #6A8991;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #F5F9FF; /* ensure blue header behind text */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dbsnapshots-grid .datagrid-body {
  overflow-y: scroll;
  background-color: #FFFFFF; /* ensure white background fills gaps between cells */
  max-height: calc(-300px + 100dvh);
  height: -moz-fit-content !important;
  height: fit-content !important;
}
.dbsnapshots-grid .datagrid-body .datagrid-row {
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  display: grid;
  column-gap: 2px;
  height: 45px;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  background-color: white;
  border-bottom: 1px solid #F2F2F2;
  color: #000;
  cursor: pointer;
  /* vertical separators between body cells */
}
.dbsnapshots-grid .datagrid-body .datagrid-row:hover {
  background-color: #c6d9ff;
}
.dbsnapshots-grid .datagrid-body .datagrid-row .datagrid-cell {
  min-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: transparent; /* inherit body bg to avoid seams */
  align-items: center;
  font-size: 14px;
  margin: 0;
}
.dbsnapshots-grid .datagrid-body .no-highlight {
  cursor: default;
}
.dbsnapshots-grid .datagrid-body .no-highlight:hover {
  background-color: #fff; /* or any other desired background color */
}`, "",{"version":3,"sources":["webpack://./src/components/Datatable/Datatable.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;AACC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AACF;AAEC;EACC,kBAAA;EACA,kBAAA;EACA,6BAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EAAA,sBAAA;AAAH;AAEG;EACC,eAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAKC;EACC,kBAAA;EACA,iCAAA;EACA,mCAAA;EAAA,8BAAA;AAHF;AAKE;EACC,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;EAAA,sBAAA;AAHH;AAKG;EACC,yBAAA;AAHJ;AAMG;EACC,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAJJ;AAQE;EACC,eAAA;AANH;AAOG;EACC,sBAAA,EAAA,0CAAA;AALJ;;AAYA;EACC,kBAAA;AATD;AAWC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AATF;AAYC;EACC,kBAAA;EACA,kBAAA;EACA,6BAAA;AAVF;AAYE;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,gCAAA;EACA,2BAAA;EAAA,sBAAA;EACA,YAAA;EAoBA,+CAAA;AA7BH;AAWG;EACC,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA,EAAA,mCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AATJ;AAmBC;EACC,kBAAA;EACA,yBAAA,EAAA,qDAAA;EACA,iCAAA;EACA,mCAAA;EAAA,8BAAA;AAjBF;AAmBE;EACC,sCAAA;EAAA,iCAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,uBAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EAqBA,2CAAA;AArCH;AAkBG;EACC,yBAAA;AAhBJ;AAmBG;EACC,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA,EAAA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAjBJ;AA0BE;EACC,eAAA;AAxBH;AAyBG;EACC,sBAAA,EAAA,0CAAA;AAvBJ","sourcesContent":[".datagrid-container {\n\tposition: relative;\n\n\t.datagrid-headers-scroll-patch {\n\t\twidth: 20px;\n\t\theight: 50px;\n\t\tposition: absolute;\n\t\tright: 0;\n\t}\n\n\t.datagrid-headers-container {\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t\tborder-top: 1px solid #D3E1ED;\n\n\t\t.datagrid-headers {\n\t\t\tdisplay: grid;\n\t\t\talign-items: center;\n\t\t\tuser-select: none;\n\t\t\tbackground-color: #F5F9FF;\n\t\t\tborder-bottom: 1px solid #E0E6EB;\n\t\t\theight: 37px;\n\t\t\tbox-sizing: border-box;\n\t\t\tmin-width: fit-content;\n\n\t\t\t.datagrid-header {\n\t\t\t\tmin-width: 50px;\n\t\t\t\tmargin: 2px 2px 2px 2px;\n\t\t\t\tcolor: #6A8991;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-align: left;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\theight: 100%;\n\t\t\t\toverflow: hidden;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t}\n\t\t}\n\t}\n\n\t.datagrid-body {\n\t\toverflow-y: scroll;\n\t\tmax-height: calc(-300px + 100dvh);\n\t\theight: fit-content !important;\n\n\t\t.datagrid-row {\n\t\t\tdisplay: grid;\n\t\t\theight: 45px;\n\t\t\talign-items: center;\n\t\t\tuser-select: none;\n\t\t\tbackground-color: white;\n\t\t\tborder-bottom: 1px solid #DBE7F1;\n\t\t\tcolor: #000;\n\t\t\tcursor: pointer;\n\t\t\tmin-width: fit-content;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #c6d9ff;\n\t\t\t}\n\n\t\t\t.datagrid-cell {\n\t\t\t\tmin-width: 50px;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\talign-items: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tmargin: 2px 2px 2px 2px;\n\t\t\t}\n\t\t}\n\n\t\t.no-highlight {\n\t\t\tcursor: default;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #fff; /* or any other desired background color */\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.dbsnapshots-grid{\n\tposition: relative;\n\n\t.datagrid-headers-scroll-patch {\n\t\twidth: 20px;\n\t\theight: 50px;\n\t\tposition: absolute;\n\t\tright: 0;\n\t}\n\n\t.datagrid-headers-container {\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t\tborder-top: 1px solid #D3E1ED;\n\n\t\t.datagrid-headers {\n\t\t\tdisplay: grid;\n\t\t\talign-items: center;\n\t\t\tcolumn-gap: 2px;\n\t\t\tuser-select: none;\n\t\t\tbackground-color: #F5F9FF;\n\t\t\tborder-bottom: 1px solid #E7E7E6;\n\t\t\tmin-width: fit-content;\n\t\t\theight: 30px;\n\n\t\t\t.datagrid-header {\n\t\t\t\tmin-width: 50px;\n\t\t\t\tmargin: 0;\n\t\t\t\tcolor: #6A8991;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 14px;\n\t\t\t\ttext-align: left;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\theight: 100%;\n\t\t\t\tpadding: 0 10px;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tbackground-color: #F5F9FF; /* ensure blue header behind text */\n\t\t\t\toverflow: hidden;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t}\n\n\t\t\t/* vertical separators between header columns */\n\t\t\t// .datagrid-header + .datagrid-header {\n\t\t\t// \tborder-left: 1px solid #E7E7E6;\n\t\t\t// }\n\t\t}\n\t}\n\n\t.datagrid-body {\n\t\toverflow-y: scroll;\n\t\tbackground-color: #FFFFFF; /* ensure white background fills gaps between cells */\n\t\tmax-height: calc(-300px + 100dvh);\n\t\theight: fit-content !important;\n\n\t\t.datagrid-row {\n\t\t\tmin-width: fit-content !important;\n\t\t\tdisplay: grid;\n\t\t\tcolumn-gap: 2px;\n\t\t\theight: 45px;\n\t\t\talign-items: center;\n\t\t\tuser-select: none;\n\t\t\tbackground-color: white;\n\t\t\tborder-bottom: 1px solid #F2F2F2;\n\t\t\tcolor: #000;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #c6d9ff;\n\t\t\t}\n\n\t\t\t.datagrid-cell {\n\t\t\t\tmin-width: 50px;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tdisplay: block;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0 10px;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tbackground-color: transparent; /* inherit body bg to avoid seams */\n\t\t\t\talign-items: center;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t/* vertical separators between body cells */\n\t\t\t// .datagrid-cell + .datagrid-cell {\n\t\t\t// \tborder-left: 1px solid #F2F2F2;\n\t\t\t// }\n\t\t}\n\n\t\t.no-highlight {\n\t\t\tcursor: default;\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #fff; /* or any other desired background color */\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
